import template from './cost-plus-invoice-view.html';
import controller from './cost-plus-invoice-view.controller';

let costPlusInvoiceViewComponent = {
  restrict: 'E',
  bindings: {
    summary: '<',
    canManage: '<',
    removingLineItemId: '<',
    onEditHours: '&',
    onRemoveLine: '&'
  },
  template,
  controller
};

export default costPlusInvoiceViewComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-details/views/cost-plus-invoice-view/cost-plus-invoice-view.component.js